<template>
  <div>
    <h1 v-html="heading" />
    <section>
      <article class="flow-group">
        <div class="header-with-icon push-down">
          <span class="icon-large" :class="'policy-type-name-' + [vueModel.Type]" />
          <ul class="no-bullet">
            <li
              v-for="(asset, index) in vueModel.Asset.AssetDetailLines"
              :key="index"
              v-html="asset"
            />
          </ul>
        </div>

        <div class="control">
          <h-3-and-tooltip
            :h3="proposalModel.Label_HasAccidentInsurance"
            :tooltip="proposalModel.Tooltip_HasAccidentInsurance"
          />

          <div class="row">
            <div class="small-6 columns">
              <div class="radio-stacked">
                <Field
                  id="hasInsuranceYes"
                  v-model="vueModel.AdditionalInformation.HasInsurance"
                  :rules="{ required: vueModel.AdditionalInformation.HasInsurance === null }"
                  type="radio"
                  name="HasInsurance"
                  :value="true"
                  :label="proposalModel.FieldName_HasAccidentInsurance"
                  @update:model-value="resetAll"
                />
                <label
                  for="hasInsuranceYes"
                  v-html="proposalModel.TakeoverModel.SharedProposalContent.LabelYes"
                />
              </div>
            </div>
            <div class="small-6 columns">
              <div class="radio-stacked">
                <Field
                  id="hasInsuranceNo"
                  v-model="vueModel.AdditionalInformation.HasInsurance"
                  :rules="{ required: vueModel.AdditionalInformation.HasInsurance === null }"
                  type="radio"
                  name="HasInsurance"
                  :value="false"
                  :label="proposalModel.FieldName_HasAccidentInsurance"
                  @update:model-value="resetAll"
                />
                <label
                  for="hasInsuranceNo"
                  v-html="proposalModel.TakeoverModel.SharedProposalContent.LabelNo"
                />
              </div>
            </div>
            <div class="small-12 columns">
              <ValidationError name="HasInsurance" />
            </div>
          </div>
        </div>

        <div
          v-if="vueModel.AdditionalInformation.HasInsurance == false"
          id="SelectedTakeoverDate"
          class="control"
        >
          <h-3-and-tooltip
            :h3="proposalModel.Label_StartDate"
            :tooltip="proposalModel.Tooltip_StartDate"
          />
          <Field
            name="TakeoverDate"
            :model-value="vueModel.AdditionalInformation.StartDate"
            :rules="{ required: true }"
            :label="proposalModel.FieldName_StartDate"
          >
            <date-picker
              id="TakeoverDate"
              name="TakeoverDate"
              :date="vueModel.AdditionalInformation.StartDate"
              :min-date="currentDate"
              class="datepicker"
              :placeholder="proposalModel.PlaceholderSelectStartDate"
              @date-changed="dateChanged"
            />
          </Field>
          <ValidationError name="TakeoverDate" />
        </div>

        <takeover-information
          v-if="vueModel.AdditionalInformation.HasInsurance"
          :external-vue-model="vueModel.AdditionalInformation.TakeoverInformation"
          :external-takeover-model="proposalModel.TakeoverModel"
          :mitid-model="mitIdModel"
        />
      </article>
    </section>
  </div>
</template>
<script>
import mixin from './CheckoutMixin.vue';
import TakeoverInformation from '@/components/Feature/Checkout/Shared/AdditionalInformation/TakeoverInformation.vue';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';
import ValidationError from '@/components/UI/ValidationError.vue';
import DatePicker from '@/components/UI/Pickadate.vue';

export default {
  name: 'Accident',
  components: {
    TakeoverInformation,
    ValidationError,
    H3AndTooltip,
    DatePicker
  },
  mixins: [mixin],
  props: {
    externalVueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    proposalModel: {
      type: Object,
      default() {
        return {};
      }
    },
    extVueModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      vueModel: this.externalVueModel,
      mitIdModel: this.extVueModel.Content.MitIdModal
    };
  },
  computed: {
    heading() {
      if (
        this.vueModel &&
        this.vueModel.Name &&
        this.proposalModel &&
        this.proposalModel.LabelExtraInformationForYour
      ) {
        return `${
          this.proposalModel.LabelExtraInformationForYour
        } ${this.vueModel.Name.toLowerCase()}`;
      }

      return '';
    }
  },
  watch: {
    'vueModel.AdditionalInformation.HasInsurance': function () {
      this.resetAll();
      if (this.vueModel.AdditionalInformation.HasInsurance) {
        this.$nextTick(() => {
          window.Utility.scrollToElem($('#PreviousInsurance'), Utility.getScrollOffset(false));
        });
      }
    },
    vueModel: {
      handler() {
        this.$emit('vue-model-updated', this.vueModel);
      },
      deep: true
    }
  },
  methods: {
    dateChanged(param) {
      this.vueModel.AdditionalInformation.StartDate = param;
    }
  }
};
</script>
